import { render } from "./AufgabenvorlagenDetailsBeschreibung.pug?vue&type=template&id=0ab50f03&lang=pug"
import script from "./AufgabenvorlagenDetailsBeschreibung.js?vue&type=script&lang=js"
export * from "./AufgabenvorlagenDetailsBeschreibung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__